var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return !_vm.isBlockedDomainOrMid
    ? _c(
        "div",
        {
          directives: [
            {
              name: "show",
              rawName: "v-show",
              value: _vm.isReady,
              expression: "isReady",
            },
          ],
          staticClass: "qp-container",
          class: {
            "qp--align-center": _vm.alignment == "center",
            "qp--align-right": _vm.alignment == "right",
            "qp--logo-first": _vm.isLogoFirst,
            "qp--align-left": _vm.alignment == "left",
          },
          style: [
            _vm.customMargins ? { margin: _vm.customMargins } : {},
            _vm.size ? { "font-size": _vm.size } : {},
            { fontFamily: _vm.zipWidgetFontStyle },
            _vm.isDarkMode ? { color: "white" } : {},
          ],
          attrs: { id: "qp-container" },
        },
        [
          _vm.isLogoFirst
            ? _c("span", {
                ref: "qp-logo-container",
                staticClass: "qp-open-modal-button",
                attrs: { id: "qp-logo-first", tabindex: "0" },
                on: {
                  click: _vm.displayModal,
                  keydown: function ($event) {
                    if (
                      !$event.type.indexOf("key") &&
                      _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")
                    )
                      return null
                    return _vm.displayModal.apply(null, arguments)
                  },
                },
              })
            : _vm._e(),
          _vm._v(" "),
          (!_vm.isLogoFirst && !_vm.subtextLayout && !_vm.is4Installments) ||
          _vm.shouldShowPayIn8
            ? _c(
                "span",
                {
                  class: {
                    "qp--nowrap": true,
                    "qp__or-text-hidden": _vm.applyGrayLabel,
                  },
                  attrs: { "data-i18n": "widget.or" },
                },
                [_vm._v("or")]
              )
            : _vm._e(),
          _vm._v(" "),
          _vm.subtextLayout
            ? _c("span", { staticClass: "qp-subtext-layout qp--nowrap" }, [
                _c(
                  "span",
                  {
                    staticClass: "qp--nowrap",
                    attrs: { "data-i18n": "widget.primary-text" },
                  },
                  [_vm._v("or buy now pay later")]
                ),
                _vm._v(" "),
                _c(
                  "span",
                  {
                    staticClass: "qp--nowrap",
                    staticStyle: { "margin-right": "0" },
                  },
                  [
                    _c("span", { attrs: { "data-i18n": "widget.with" } }, [
                      _vm._v(" with "),
                    ]),
                    _vm._v(" "),
                    _c("span", {
                      ref: "qp-logo-container",
                      class: {
                        "qp-open-modal-button": true,
                        "qp--ada-disabled": _vm.disableAdaCompliance,
                      },
                      attrs: { id: "qp-logo-last" },
                      on: {
                        click: _vm.displayModal,
                        keydown: function ($event) {
                          if (
                            !$event.type.indexOf("key") &&
                            _vm._k(
                              $event.keyCode,
                              "enter",
                              13,
                              $event.key,
                              "Enter"
                            )
                          )
                            return null
                          return _vm.displayModal.apply(null, arguments)
                        },
                      },
                    }),
                  ]
                ),
                _vm._v(" "),
                _c(
                  "span",
                  {
                    class: {
                      "qp-info-icon": true,
                      "qp-open-modal-button": true,
                      "qp--ada-disabled": _vm.disableAdaCompliance,
                    },
                    attrs: { tabindex: "0" },
                    on: {
                      click: _vm.displayModal,
                      keydown: function ($event) {
                        if (
                          !$event.type.indexOf("key") &&
                          _vm._k(
                            $event.keyCode,
                            "enter",
                            13,
                            $event.key,
                            "Enter"
                          )
                        )
                          return null
                        return _vm.displayModal.apply(null, arguments)
                      },
                    },
                  },
                  [
                    _c(
                      "svg",
                      {
                        attrs: {
                          alt: "Info icon, when clicked, opens infographic about the option of buying this item with 4 installment payments",
                          version: "1.1",
                          width: "15",
                          height: "15",
                          viewBox: "0 0 15 15",
                          xmlns: "http://www.w3.org/2000/svg",
                        },
                      },
                      [
                        _c("title", [
                          _vm._v(
                            "QuadPay - Pay in 4 installments, no interest."
                          ),
                        ]),
                        _vm._v(" "),
                        _c(
                          "g",
                          { attrs: { fill: "none", "fill-rule": "evenodd" } },
                          [
                            _c("g", [
                              _c("path", {
                                attrs: {
                                  d: "M7 10V6.125",
                                  stroke: "black",
                                  "stroke-linecap": "round",
                                  "stroke-linejoin": "round",
                                },
                              }),
                              _vm._v(" "),
                              _c("path", {
                                attrs: {
                                  "fill-rule": "evenodd",
                                  "clip-rule": "evenodd",
                                  d: "M7 12.625C10.1066 12.625 12.625 10.1066 12.625 7C12.625 3.8934 10.1066 1.375 7 1.375C3.8934 1.375 1.375 3.8934 1.375 7C1.375 10.1066 3.8934 12.625 7 12.625Z",
                                  stroke: "black",
                                  "stroke-linecap": "round",
                                  "stroke-linejoin": "round",
                                },
                              }),
                              _vm._v(" "),
                              _c("circle", {
                                attrs: {
                                  cx: "7",
                                  cy: "4.5",
                                  r: "0.25",
                                  stroke: "black",
                                  "stroke-width": "0.5",
                                },
                              }),
                            ]),
                          ]
                        ),
                      ]
                    ),
                  ]
                ),
              ])
            : _vm._e(),
          _vm._v(" "),
          _vm.shouldShowPayIn8
            ? [
                _vm.shouldShowPayInNMin
                  ? [
                      _c("div", { staticClass: "qp--nowrap" }, [
                        _vm._v("pay in installments on orders"),
                      ]),
                      _vm._v(" "),
                      _c("div", { staticClass: "qp--line-break" }),
                      _vm._v(" "),
                      _c("div", { staticClass: "qp--nowrap" }, [
                        _vm._v("\n        over\n        "),
                        _c(
                          "span",
                          {
                            staticClass: "qp-price",
                            style: _vm.priceColor
                              ? { color: _vm.priceColor }
                              : {},
                          },
                          [
                            _vm._v(
                              _vm._s(
                                _vm.formatUSDCurrency(_vm.paymentSchedulesMin)
                              )
                            ),
                          ]
                        ),
                      ]),
                    ]
                  : _vm.shouldShowPayInNMax
                  ? [
                      _c("div", { staticClass: "qp--nowrap" }, [
                        _vm._v("pay in installments on orders"),
                      ]),
                      _vm._v(" "),
                      _c("div", { staticClass: "qp--line-break" }),
                      _vm._v(" "),
                      _c("div", { staticClass: "qp--nowrap" }, [
                        _vm._v("\n        under\n        "),
                        _c(
                          "span",
                          {
                            staticClass: "qp-price",
                            style: _vm.priceColor
                              ? { color: _vm.priceColor }
                              : {},
                          },
                          [
                            _vm._v(
                              _vm._s(
                                _vm.formatUSDCurrency(_vm.paymentSchedulesMax)
                              )
                            ),
                          ]
                        ),
                      ]),
                    ]
                  : [
                      _c("div", { staticClass: "qp--nowrap" }, [
                        _vm._v(
                          "\n        pay in installments as low as\n        "
                        ),
                        _c(
                          "span",
                          {
                            staticClass: "qp-price",
                            style: _vm.priceColor
                              ? { color: _vm.priceColor }
                              : {},
                          },
                          [
                            _vm._v(
                              _vm._s(
                                _vm.formatUSDCurrency(
                                  _vm.lowestPaymentScheduleInstallmentAmount
                                )
                              )
                            ),
                          ]
                        ),
                      ]),
                      _vm._v(" "),
                      !_vm.singleLine
                        ? _c("div", { staticClass: "qp--line-break" })
                        : _vm._e(),
                    ],
              ]
            : [
                _c("span", { staticClass: "qp--nowrap" }, [
                  _c("span", [_vm._v(_vm._s(_vm.widgetVerbiageTranslated))]),
                ]),
                _vm._v(" "),
                _vm.shouldShowInstallmentAmount ||
                (!_vm.shouldShowInstallmentAmount && _vm.hasValidAmount)
                  ? _c(
                      "span",
                      {
                        staticClass: "qp--nowrap",
                        attrs: { id: "displayCustom" },
                      },
                      [
                        _c(
                          "span",
                          {
                            directives: [
                              {
                                name: "show",
                                rawName: "v-show",
                                value:
                                  _vm.totalAmount <= _vm.max &&
                                  _vm.totalAmount >= _vm.min,
                                expression:
                                  "totalAmount <= max && totalAmount >= min",
                              },
                            ],
                            attrs: { "data-i18n": "widget.price-separator-of" },
                          },
                          [_vm._v("of")]
                        ),
                        _vm._v(" "),
                        _c(
                          "span",
                          {
                            directives: [
                              {
                                name: "show",
                                rawName: "v-show",
                                value: _vm.totalAmount > _vm.max,
                                expression: "totalAmount > max",
                              },
                            ],
                            attrs: {
                              "data-i18n": "widget.price-separator-up-to",
                            },
                          },
                          [_vm._v("on orders up to")]
                        ),
                        _vm._v(" "),
                        _c(
                          "span",
                          {
                            directives: [
                              {
                                name: "show",
                                rawName: "v-show",
                                value: _vm.totalAmount < _vm.min,
                                expression: "totalAmount < min",
                              },
                            ],
                            attrs: {
                              "data-i18n": "widget.price-separator-over",
                            },
                          },
                          [_vm._v("on orders over")]
                        ),
                        _vm._v(" "),
                        _c(
                          "span",
                          {
                            staticClass: "qp-price",
                            style: _vm.priceColor
                              ? { color: _vm.priceColor }
                              : {},
                            attrs: { id: "qp-price" },
                          },
                          [
                            _vm.totalAmount <= _vm.max &&
                            _vm.totalAmount >= _vm.min
                              ? _c("span", [
                                  _c(
                                    "span",
                                    {
                                      attrs: { "data-i18n": "currency.number" },
                                    },
                                    [_vm._v("$")]
                                  ),
                                  _vm._v(_vm._s(_vm.installmentAmount)),
                                ])
                              : _vm.totalAmount > _vm.max
                              ? _c("span", [
                                  _c(
                                    "span",
                                    {
                                      attrs: { "data-i18n": "currency.number" },
                                    },
                                    [_vm._v("$")]
                                  ),
                                  _vm._v(_vm._s(_vm.max)),
                                ])
                              : _vm.totalAmount < _vm.min
                              ? _c("span", [
                                  _c(
                                    "span",
                                    {
                                      attrs: { "data-i18n": "currency.number" },
                                    },
                                    [_vm._v("$")]
                                  ),
                                  _vm._v(_vm._s(_vm.min)),
                                ])
                              : _vm._e(),
                          ]
                        ),
                      ]
                    )
                  : _vm._e(),
              ],
          _vm._v(" "),
          _vm.applyGrayLabel
            ? _c("div", { staticClass: "qp--line-break" })
            : _vm._e(),
          _vm._v(" "),
          !_vm.isLogoFirst && !_vm.subtextLayout
            ? _c(
                "span",
                {
                  staticClass: "qp--nowrap",
                  class: {
                    "qp--wrapped-content": _vm.hasAlignment,
                    "qp--align-center": _vm.alignment == "center",
                    "qp--align-right": _vm.alignment == "right",
                    "qp--align-left": _vm.alignment == "left",
                  },
                },
                [
                  _vm.displayPromotions === "display_promotions" &&
                  _vm.promotionObject &&
                  _vm.promotionMinimum
                    ? _c("span", { staticClass: "qp-promotional-discount" }, [
                        _c("span", { staticClass: "qp-discount-plus" }, [
                          _vm._v("+"),
                        ]),
                        _vm._v(" "),
                        _c(
                          "span",
                          { attrs: { "data-i18n": "widget.promo-spend" } },
                          [_vm._v("spend")]
                        ),
                        _vm._v(" "),
                        _c("span", [
                          _vm._v(
                            "$" + _vm._s(this.promotionObject.orderAmount) + ","
                          ),
                        ]),
                        _vm._v(" "),
                        _c(
                          "span",
                          { attrs: { "data-i18n": "widget.promo-get" } },
                          [_vm._v("get")]
                        ),
                        _vm._v(" "),
                        _c("span", [
                          _vm._v(
                            "$" + _vm._s(this.promotionObject.promotionDiscount)
                          ),
                        ]),
                        _vm._v(" "),
                        _c(
                          "span",
                          { attrs: { "data-i18n": "widget.promo-off" } },
                          [_vm._v("off")]
                        ),
                      ])
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.displayPromotions === "display_promotions" &&
                  _vm.promotionObject &&
                  !_vm.promotionMinimum
                    ? _c("span", { staticClass: "qp-promotional-discount" }, [
                        _c("span", [
                          _vm._v(
                            "+ $" +
                              _vm._s(this.promotionObject.promotionDiscount)
                          ),
                        ]),
                        _vm._v(" "),
                        _c(
                          "span",
                          { attrs: { "data-i18n": "widget.promo-off" } },
                          [_vm._v("off")]
                        ),
                      ])
                    : _vm._e(),
                  _vm._v(" "),
                  _c("span", { attrs: { "data-i18n": "widget.with" } }, [
                    _vm._v(" with "),
                  ]),
                  _vm._v(" "),
                  _vm.applyGrayLabel
                    ? _c("img", {
                        staticClass: "qp-gray-label-logo",
                        attrs: {
                          src: _vm.logoUrl,
                          alt: _vm.modalGrayLabelName,
                          title: _vm.modalGrayLabelName,
                        },
                      })
                    : _vm._e(),
                  _vm._v(" "),
                  _c("span", {
                    ref: "qp-logo-container",
                    staticClass: "qp-open-modal-button",
                    attrs: { id: "qp-logo-last" },
                    on: {
                      click: _vm.displayModal,
                      keydown: function ($event) {
                        if (
                          !$event.type.indexOf("key") &&
                          _vm._k(
                            $event.keyCode,
                            "enter",
                            13,
                            $event.key,
                            "Enter"
                          )
                        )
                          return null
                        return _vm.displayModal.apply(null, arguments)
                      },
                    },
                  }),
                  _vm._v(" "),
                  _vm.displayPromotions == "display_promotions"
                    ? _c(
                        "span",
                        {
                          staticClass: "qp-open-modal-button qp-terms-link",
                          attrs: { "data-i18n": "widget.promo-terms" },
                          on: {
                            click: _vm.displayModal,
                            keydown: function ($event) {
                              if (
                                !$event.type.indexOf("key") &&
                                _vm._k(
                                  $event.keyCode,
                                  "enter",
                                  13,
                                  $event.key,
                                  "Enter"
                                )
                              )
                                return null
                              return _vm.displayModal.apply(null, arguments)
                            },
                          },
                        },
                        [_vm._v("Terms apply")]
                      )
                    : [
                        _vm.isLearnMoreButtonFeatureEnabled
                          ? _c(
                              "button",
                              {
                                staticClass: "qp-open-modal-button learn-more",
                                on: {
                                  click: _vm.displayModal,
                                  keydown: function ($event) {
                                    if (
                                      !$event.type.indexOf("key") &&
                                      _vm._k(
                                        $event.keyCode,
                                        "enter",
                                        13,
                                        $event.key,
                                        "Enter"
                                      )
                                    )
                                      return null
                                    return _vm.displayModal.apply(
                                      null,
                                      arguments
                                    )
                                  },
                                },
                              },
                              [_vm._v("\n        Learn more\n      ")]
                            )
                          : _c("span", {
                              ref: "qp-info-icon-container",
                              staticClass: "qp-open-modal-button qp-info-icon",
                              on: {
                                click: _vm.displayModal,
                                keydown: function ($event) {
                                  if (
                                    !$event.type.indexOf("key") &&
                                    _vm._k(
                                      $event.keyCode,
                                      "enter",
                                      13,
                                      $event.key,
                                      "Enter"
                                    )
                                  )
                                    return null
                                  return _vm.displayModal.apply(null, arguments)
                                },
                              },
                            }),
                      ],
                ],
                2
              )
            : _vm._e(),
          _vm._v(" "),
          !_vm.subtextLayout &&
          _vm.isLogoFirst &&
          _vm.displayPromotions != "display_promotions"
            ? [
                _vm.isLearnMoreButtonFeatureEnabled
                  ? _c(
                      "button",
                      {
                        staticClass: "qp-open-modal-button learn-more",
                        on: {
                          click: _vm.displayModal,
                          keydown: function ($event) {
                            if (
                              !$event.type.indexOf("key") &&
                              _vm._k(
                                $event.keyCode,
                                "enter",
                                13,
                                $event.key,
                                "Enter"
                              )
                            )
                              return null
                            return _vm.displayModal.apply(null, arguments)
                          },
                        },
                      },
                      [_vm._v("\n      Learn more\n    ")]
                    )
                  : _c("span", {
                      ref: "qp-info-icon-container",
                      staticClass: "qp-open-modal-button qp-info-icon",
                      on: {
                        click: _vm.displayModal,
                        keydown: function ($event) {
                          if (
                            !$event.type.indexOf("key") &&
                            _vm._k(
                              $event.keyCode,
                              "enter",
                              13,
                              $event.key,
                              "Enter"
                            )
                          )
                            return null
                          return _vm.displayModal.apply(null, arguments)
                        },
                      },
                    }),
              ]
            : _vm._e(),
          _vm._v(" "),
          _vm.displayPromotions === "display_promotions" &&
          _vm.isLogoFirst &&
          _vm.promotionObject &&
          !_vm.promotionMinimum
            ? _c("span", { staticClass: "qp-promotional-discount" }, [
                _c("span", [
                  _vm._v(
                    "+ $" + _vm._s(this.promotionObject.promotionDiscount)
                  ),
                ]),
                _vm._v(" "),
                _c("span", { attrs: { "data-i18n": "widget.promo-off" } }, [
                  _vm._v("off"),
                ]),
              ])
            : _vm._e(),
          _vm._v(" "),
          _vm.displayPromotions === "display_promotions" &&
          _vm.isLogoFirst &&
          _vm.promotionObject &&
          _vm.promotionMinimum
            ? _c("span", { staticClass: "qp-promotional-discount" }, [
                _c("span", { staticClass: "qp-discount-plus" }, [_vm._v("+")]),
                _vm._v(" "),
                _c("span", { attrs: { "data-i18n": "widget.promo-spend" } }, [
                  _vm._v("spend"),
                ]),
                _vm._v(" "),
                _c("span", [
                  _vm._v("$" + _vm._s(this.promotionObject.orderAmount) + ","),
                ]),
                _vm._v(" "),
                _c("span", { attrs: { "data-i18n": "widget.promo-get" } }, [
                  _vm._v("get"),
                ]),
                _vm._v(" "),
                _c("span", [
                  _vm._v("$" + _vm._s(this.promotionObject.promotionDiscount)),
                ]),
                _vm._v(" "),
                _c("span", { attrs: { "data-i18n": "widget.promo-off" } }, [
                  _vm._v("off"),
                ]),
              ])
            : _vm._e(),
          _vm._v(" "),
          _vm.displayPromotions == "display_promotions" && _vm.isLogoFirst
            ? _c(
                "span",
                {
                  staticClass: "qp-open-modal-button qp-terms-link",
                  attrs: { "data-i18n": "widget.promo-terms" },
                  on: {
                    click: _vm.displayModal,
                    keydown: function ($event) {
                      if (
                        !$event.type.indexOf("key") &&
                        _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")
                      )
                        return null
                      return _vm.displayModal.apply(null, arguments)
                    },
                  },
                },
                [_vm._v("Terms apply")]
              )
            : _vm._e(),
        ],
        2
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }